import { StyledIconBase } from "@styled-icons/styled-icon";
import { Row, Col } from "components/primitives";
import { FC, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import styled from "styled-components";

import { SavedSchedule } from "./OrganiseScheduleSetting";

interface Props {
  savedSchedules: SavedSchedule[];
  hasClosed?: () => void;
  changeActiveSchedule: (schedule: SavedSchedule) => void;
}

export const SavedSchedulesModal: FC<Props> = ({
  savedSchedules,
  hasClosed,
  changeActiveSchedule,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const onClose = () => {
    setIsClosing(true);
  };

  const handleScheduleClick = (schedule: SavedSchedule) => {
    if (schedule) {
      changeActiveSchedule(schedule);
    }
    onClose();
  };

  return (
    <Modal
      show={!isClosing}
      onHide={onClose}
      size="lg"
      onExited={hasClosed}
      centered
      className="no-drag"
    >
      <Modal.Header>
        <HeaderRow>Saved Schedules</HeaderRow>
      </Modal.Header>
      <Modal.Body>
        {!savedSchedules ? (
          <p>No saved schedules</p>
        ) : (
          <>
            <p style={{ marginBottom: "15px" }}>Please select a Schedule to edit.</p>
            <InnerContainer>
              {savedSchedules?.map((schedule) => {
                return (
                  <ScheduleButton
                    schedule={schedule}
                    key={schedule.id}
                    onClick={() => handleScheduleClick(schedule)}
                  >
                    {schedule.name}
                  </ScheduleButton>
                );
              })}
            </InnerContainer>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

const HeaderRow = styled(Row)`
  color: var(--secondary);
  align-items: center;
  gap: 10px;
  height: 30px;
  font-size: 16pt;
  font-weight: 600;

  ${StyledIconBase} {
    height: 100%;
  }
`;

const ScheduleButton = styled(Button)`
  background-color: var(--primary);
  box-shadow: none;
  color: black;
  width: 100%;
  font-weight: 600;
  font-size: 12pt;
  padding: 10px;
  flex: 0 0 calc(25% - 15px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const InnerContainer = styled(Row)`
  gap: 10px;
  flex-wrap: wrap;
`;
